export default __webpack_public_path__ + "static/media/nftfr.6cdf34b0.gif";